import { render, staticRenderFns } from "./ReferralListSection.vue?vue&type=template&id=efff32fa&scoped=true"
import script from "./ReferralListSection.vue?vue&type=script&lang=js"
export * from "./ReferralListSection.vue?vue&type=script&lang=js"
import style0 from "./ReferralListSection.vue?vue&type=style&index=0&id=efff32fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efff32fa",
  null
  
)

export default component.exports